import './App.css';
import { SortingVisualizer } from './sortingVisualizer/SortingVisualizer.jsx';

function App() {
  return (
    <div className='App'>
      <SortingVisualizer />
    </div>
  );
}

export default App;
